import { ValidateJSModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModelValidator from '../location';
import { LocationModel } from '../types';

interface LocationCityCountryModel {
  city: LocationModel['city']
  country: LocationModel['country']
}

const locationCityCountryModelValidator: ValidateJSModel<LocationCityCountryModel> = {
  city: locationModelValidator.city as ValidateJSModelAttribute<LocationCityCountryModel, 'city'>,
  country: locationModelValidator.country as ValidateJSModelAttribute<
    LocationCityCountryModel,
    'country'
  >,
};

export default locationCityCountryModelValidator;
